module.exports = __webpack_public_path__ + "img/image-19.85a9cb3c.jpg";